

import * as React from "react";

var icon = require("./transcriptomics.png");

var tools = /* array */[
  {
    term: /* Bowtie2 */-338593844,
    description: "Ultra-fast, sensitive gapped, short-read aligner."
  },
  {
    term: /* STAR */924625874,
    description: "Ultra-fast universal RNA-seq aligner."
  },
  {
    term: /* RSEM */913487465,
    description: "Quantify gene and transcript expression from RNA-seq data."
  },
  {
    term: /* TopHat2 */862607756,
    description: "Sensitive and accurate spliced-read aligner."
  },
  {
    term: /* HISAT2 */151037165,
    description: "Fast spliced aligner with low memory requirements."
  },
  {
    term: /* Cufflinks */674407783,
    description: "Assemble transcripts, estimate transcript abundances, and test for differential expression."
  },
  {
    term: /* Kallisto */653925531,
    description: "Quantify transcript abundance from RNA-Seq data."
  },
  {
    term: /* DESeq2 */571755476,
    description: "Test for differential expression based on a model using the negative binomial distribution."
  },
  {
    term: /* EdgeR */-49423019,
    description: "Examine differential expression of replicated count data based on several statistical methods including empirical Bayes estimation, exact tests, generalized linear models and quasi-likelihood tests."
  },
  {
    term: /* EBSeq */-427462846,
    description: "Empirical Bayes approach to identify differentially expressed genes and isoforms."
  },
  {
    term: /* LimmaVoom */-235857605,
    description: "Linear model analysis tools for differential expression assessment of genes from RNA-seq read counts."
  },
  {
    term: /* Trinity */-137196277,
    description: "De novo reconstruction of transcriptomes from RNA-seq data."
  },
  {
    term: /* TransDecoder */-544416676,
    description: "Identify candidate coding regions within transcript sequences."
  },
  {
    term: /* BUSCO */954245580,
    description: "Assessment of genome assembly, gene set, and transcriptome completeness."
  },
  {
    term: /* DETONATE */756135328,
    description: "Evaluate de novo transcriptome assemblies from RNA-seq data."
  },
  {
    term: /* Trinotate */-273821654,
    description: "Automatic functional annotation of de novo assembled transcriptomes."
  },
  {
    term: /* EricScript */-905605358,
    description: "Computational framework for the discovery of gene fusions in paired end RNA-seq data."
  },
  {
    term: /* GSEA */791502216,
    description: "Gene Set Enrichment Analysis, a knowledge-based approach for interpreting genome-wide expression profiles."
  },
  {
    term: /* WCGNA */-1000609874,
    description: "Weighted Gene Correlation Network Analysis, a systems biology method for describing the correlation patterns among genes from expression data."
  },
  {
    term: /* Cytoscape */-265545067,
    description: "Open source software platform for visualizing complex networks and integrating these with any type of attribute data."
  }
];

var fileTypes = /* array */[
  /* Csv */3357606,
  /* Tsv */4202999,
  /* Sam */4149247,
  /* Bam */3303854,
  /* Cram */748691835,
  /* Fasta */243398181,
  /* Fastq */243398197,
  /* Bed */3304737,
  /* Wig */4349941,
  /* BigBed */484974721,
  /* BigWig */486019925,
  /* BedGraph */-809444755,
  /* Gtf */3556729,
  /* Gff3 */792454412,
  /* Gct */3552952
];

var visualAnalytics = /* array */[
  {
    icon: /* Heatmap */988997452,
    description: "Expression similarity of genes that can be clustered and reordered to reveal patterns among samples."
  },
  {
    icon: /* Dendrogram */-508885141,
    description: "Tree-like diagrams from clustering samples by expression correlation."
  },
  {
    icon: /* VolcanoPlot */586017299,
    description: "Visualize DEG on a scatter-plot of fold change vs its significance (negative log of the p value)."
  },
  {
    icon: /* VennDiagram */83361156,
    description: "Compare gene lists across tissue types or conditions."
  },
  {
    icon: /* ParallelCoordinates */-322318508,
    description: "Visualize standardized expression data from time series experiments or longitudinal analyses."
  },
  {
    icon: /* PrincipalCoordinates */-496309491,
    description: "Reduce dimension of expression data, filter noise, visualize similarities between the biological samples and relate to experimental conditions."
  },
  {
    icon: /* PathwayMap */316537906,
    description: "Maps of biochemical capability, or signal transduction of enriched gene lists."
  },
  {
    icon: /* NetworkDiagram */-449223643,
    description: "Understand gene co-expression and gene-trait relationships."
  },
  {
    icon: /* GenomeBrowser */-265814703,
    description: "View your transcriptome alignments from a BAM file or as a graph along with reference annotation."
  },
  {
    icon: /* Cytoscape */-265545067,
    description: "Open source software platform for visualizing complex networks and integrating these with any type of attribute data."
  }
];

var description = React.createElement("p", undefined, "RNA-seq with next-generation sequencing (NGS) has become the method of\n    choice for researchers interested in characterizing genome-wide gene and\n    transcript expression in a single experiment.");

var overview = React.createElement(React.Fragment, undefined, React.createElement("p", undefined, "RNA-seq is widely used for profiling expression of protein-coding and\n        non-coding transcripts (small and long) in both model species (human,\n        mouse, Arabidopsis, maize, etc.) with well-defined transcriptome, and\n        species with no reference transcriptome. RNA-Seq methods can provide\n        precise measurement of gene and transcript levels, determine strand\n        orientation, map alternate transcripts with high confidence,\n        characterize gene fusions, identify single nucleotide variants and help\n        discover novel gene isoforms."), React.createElement("p", undefined, "RNA-seq has been utilized for diverse application areas in biology. For\n        example, in pathobiology of cancer to dissect the link between tumor\n        genotypes and molecular subtypes of cancer, to aid in tumor\n        classification and progression, and to characterize multiple drug\n        susceptible tumorigenic pathways towards discovering new biomarkers or\n        therapeutic strategies. In agriculture, RNA-seq methods have been used\n        to assess transcript diversity across different varieties, characterize\n        mode of action of trait genes, and discover new genes or targets for\n        crop/trait improvement (yield and other agronomic traits, disease\n        resistance, insect tolerance, quality traits, etc)."), React.createElement("p", undefined, "Tertiary analysis of expression datasets is necessary to understand\n        affected genes and pathways and this is typically accomplished through\n        differential expression analysis, enrichment analysis, and co-expression\n        based network analysis, to create a global picture of cellular function."), React.createElement("p", undefined, "Our integrated data solutions lets you manage and explore your primary\n        expression data, as well as outputs from tertiary analysis tools.\n        Explore data outputs from transcriptome characterization tools by simply\n        uploading your expression matrix or results from differential expression\n        analysis. Search over your data, subset your data, perform statistical\n        analysis and visualize the data."));

var id = "transcriptomics";

var title = "Transcriptomics";

export {
  id ,
  title ,
  icon ,
  overview ,
  description ,
  tools ,
  fileTypes ,
  visualAnalytics ,
  
}
/* icon Not a pure module */
